import { useTranslation } from 'react-i18next'
import { useParams, useSearchParams } from 'react-router-dom'

import PageBody from 'components/atoms/PageBody'
import PageHeading from 'components/atoms/PageHeading'

import { crudActionsMap } from 'utils/helpers'
import PlopReportForm from 'components/organisms/forms/PlopReportForm'
import PlopReport from 'components/utilized/plop/PlopReport'

const PlopReportCrudPage = () => {
  const { t } = useTranslation()
  const params = useParams()
  const id = params?.id

  const [searchParams] = useSearchParams();
  const student_id = searchParams.get('student_id')

  const action = crudActionsMap[params['*']?.split('/')?.[1]]
  const viewOnly = action === 'view' || action === 'delete'

  return (
    <>
      <PageBody>
        {id && <PlopReport id={id}/>}
        {!id && <PlopReportForm 
          action={action} 
          id={id} 
          studentId={student_id} 
          viewOnly={viewOnly} 
          isStudentProfile={!!student_id} />}
      </PageBody>
    </>
  )
}
export default PlopReportCrudPage
